import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'
import Form from 'component/utils/Form'
import Field from 'component/utils/Field'
import Input from 'component/utils/Input'
import Alert from 'component/utils/Alert'

class JustificationForm extends Component {
  state = {
    alert: {
      show: false,
      message: '',
    },
  }

  static propTypes = {
    fields: PropTypes.object.isRequired,
    values: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
    setValueToField: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    justification: PropTypes.object,
    updateJustification: PropTypes.func,
  }

  handleAlert = (message) => {
    this.setState((prevState) => ({
      alert: {
        show: !prevState.alert.show,
        message: message || '',
      },
    }))
  }

  handleSubmit = (event) => {
    event.preventDefault()
    const { onSubmit, translate, fields, justification } = this.props
    const value =
      fields &&
      fields.dsJustification &&
      fields.dsJustification.input &&
      fields.dsJustification.input.value

    if (!value || !value.length) {
      return
    }

    if (value.length > 200) {
      this.handleAlert(
        translate('demarcate.justification.dsJustificationMaxSize').replace(
          '#',
          '200'
        )
      )
      return
    }

    let params = { dsJustificationDisapprovalUseConsumption: value }

    if (justification) {
      params = {
        ...justification,
        dsJustificationDisapprovalUseConsumption: value,
      }
    }

    this.handleChange('dsJustification', '')
    onSubmit(params)
  }

  renderValueForm = () => {
    const { fields, justification } = this.props
    if (fields.dsJustification.input && fields.dsJustification.input.value) {
      return fields.dsJustification.input.value
    }

    if (
      justification &&
      justification.dsJustificationDisapprovalUseConsumption
    ) {
      return justification.dsJustificationDisapprovalUseConsumption
    }

    return ''
  }

  handleChange = (id, value) => this.props.setValueToField(id, value)

  render() {
    const { translate, fields, updateJustification, justification } = this.props

    const { alert } = this.state

    return (
      <form onSubmit={this.handleSubmit}>
        <Row>
          <Col lg={6} lgOffset={3} md={6} mdOffset={3} sm={12} xs={12}>
            <Col lg={8} md={8} sm={12} xs={12}>
              <Field {...fields.dsJustification}>
                <Input
                  id='dsJustification'
                  {...fields.dsJustification.input}
                  value={this.renderValueForm()}
                  onChange={(e) =>
                    this.handleChange('dsJustification', e.target.value)
                  }
                />
              </Field>
            </Col>

            <Col lg={2} md={2} sm={12} xs={12} className='margin-top'>
              <button className='button button-primary button-full'>
                {translate(
                  justification
                    ? 'justification.disapproval.use.and.consumption.form.label.alt'
                    : 'justification.disapproval.use.and.consumption.form.label.cad'
                )}
              </button>
            </Col>

            <Col lg={2} md={2} sm={12} xs={12} className='margin-top'>
              <button
                className='button-hollow button-hollow-danger button-full'
                onClick={() => {
                  this.handleChange('dsJustification', '')
                  updateJustification(null)
                }}
              >
                {translate('demarcate.justification.clean')}
              </button>
            </Col>
          </Col>
        </Row>

        {alert.show && (
          <Alert
            handleAlert={this.handleAlert}
            text={translate(alert.message)}
            translate={translate}
            textButton={translate('irc.gama.closeAlert')}
            preventDefault
            size='sm'
          />
        )}
      </form>
    )
  }
}

const fields = ['dsJustification']

export default Form({ fields })(JustificationForm)

export { JustificationForm }
